// src/utils/cities.js
// Shared city data for applicant forms

export const ALL_CITIES = {
  'es-mx': [
    { "city_code": "CJS", "city_name": "Ciudad Juarez" },
    { "city_code": "GDL", "city_name": "Guadalajara" },
    { "city_code": "HMO", "city_name": "Hermosillo" },
    { "city_code": "MAM", "city_name": "Matamoros" },
    { "city_code": "MID", "city_name": "Merida" },
    { "city_code": "MEX", "city_name": "Mexico City" },
    { "city_code": "MTY", "city_name": "Monterrey" },
    { "city_code": "NOG", "city_name": "Nogales" },
    { "city_code": "NLD", "city_name": "Nuevo Laredo" },
    { "city_code": "TIJ", "city_name": "Tijuana" }
  ],
  'es-hn': [
    { "city_code": "TGU", "city_name": "Tegucigalpa" }
  ]
};
